<template>
  <div class="custom-text">
    <div :key="i" v-for="(el, i) in data">
      <hr v-if="i != 0" class="mb-3" />
      <vs-row class="mb-3">
        <vs-col vs-xs="12" vs-sm="6" vs-lg="6">
          <table>
            <tr>
              <td class="font-semibold">
                {{ $t('order_status') | capitalize }}:
              </td>
              <vs-chip
                :color="
                  el.status_color !== undefined
                    ? el.status_color.trim()
                    : '#F4F4F4'
                "
                >{{ el.status_name }}</vs-chip
              >
            </tr>
            <tr>
              <td class="font-semibold">
                {{ $t('creation_date') | capitalize }}:
              </td>
              <td>{{ el.created_at }}</td>
            </tr>
            <tr>
              <td class="font-semibold">
                {{ $t('approval_date') | capitalize }}:
              </td>
              <td>{{ el.approval_date }}</td>
            </tr>
            <tr>
              <td class="font-semibold">
                {{ $t('confirmation_date') | capitalize }}:
              </td>
              <td>{{ el.confirmation_date }}</td>
            </tr>
          </table>
        </vs-col>
        <vs-col vs-xs="12" vs-sm="6" vs-lg="6">
          <table>
            <tr>
              <td class="font-semibold">{{ $t('invoice') | capitalize }}:</td>
              <td class="font-semibold"><a class="pointer" @click.prevent="showDetails(el.review_order_id)">{{ el.invoice_id }}</a></td>
            </tr>
            <tr>
              <td class="font-semibold">
                {{ $t('invoice_type') | capitalize }}:
              </td>
              <td>{{ el.invoice_type }}</td>
            </tr>
            <tr>
              <td class="font-semibold">
                {{ $t('requirement_number') | capitalize }}:
              </td>
              <td>{{ el.no_ped }}</td>
            </tr>
            <!-- <tr>
              <td class="font-semibold">
                {{ $t('requirement_key') | capitalize }}:
              </td>
              <td>?????</td>
            </tr>
            <tr>
              <td class="font-semibold">{{ $t('bundle') | capitalize }}:</td>
              <td>?????</td>
            </tr> -->
          </table>
        </vs-col>
      </vs-row>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => []
    }
  },
  methods:{
    showDetails(id){
      let routeData = this.$router.resolve({
        name: 'review-order-details',
        params: {
          id: id
        }
      })
      window.open(routeData.href, '_blank');  
    }
  }
}
</script>
